export default __webpack_public_path__ + "static/media/ic_dai_40.eb3c180f.svg";